import { Text } from '@village/ui';
import { AxiosError } from 'axios';
import { useCountly } from 'epion-checkin/hooks/use-countly';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './styles';
import { EpionCheckInHeader } from '../header';

interface Props {
    error: AxiosError | Error;
}

export const ErrorBoundaryFallback: FC<Props> = ({ error }) => {
    const { t } = useTranslation();
    const { addCountlyEvent } = useCountly();

    useEffect(() => {
        addCountlyEvent({
            key: 'errorScreen',
            segmentation: {
                errorName: error.name,
                errorMessage: error.message,
            },
        });
    }, [error, addCountlyEvent]);

    return (
        <Styled.GlobalContainer>
            <EpionCheckInHeader page="welcome" />
            <Styled.Container data-testid="error-boundary-screen">
                <Styled.Wrapper>
                    <Styled.Content>
                        <Styled.Title type="h3">{t('errorBoundary.title')}</Styled.Title>
                        <Text type="body1">{t('errorBoundary.description')}</Text>
                    </Styled.Content>
                </Styled.Wrapper>
            </Styled.Container>
        </Styled.GlobalContainer>
    );
};
